export default __webpack_public_path__ + "static/media/Gowri-Shankar.5b524f9f.webp";